export const PUBLIC = 'PUBLIC';
export const REMEMBERED = 'REMEMBERED';
export const LOGGED_IN = 'LOGGED_IN';
export const ELEVATED = 'ELEVATED';
export const SUPERUSER = 'SUPERUSER';

export const AuthenticationLevel = Object.freeze({
  PUBLIC,
  REMEMBERED,
  LOGGED_IN,
  ELEVATED,
  SUPERUSER,
});

const AuthenticationLevelValues = Object.keys(AuthenticationLevel);

/**
 * Verifies if user has the required authentication level.
 *
 * @param user the User object, could be get from Redux store using 'state.user'
 * @param requiredAuthenticationLevel any of {@link AuthenticationLevel; optional, if empty 'PUBLIC' (i.e. not requiring authentication) is assumed
 * @returns {boolean}
 */
export const hasAccess = (user, requiredAuthenticationLevel = AuthenticationLevel.PUBLIC) => {
  if (requiredAuthenticationLevel === AuthenticationLevel.PUBLIC) return true; // for PUBLIC do not even check the user

  const requiredAuthenticationLevelIdx = AuthenticationLevelValues.indexOf(requiredAuthenticationLevel);
  const userAuthenticationLevelIdx = AuthenticationLevelValues
    .indexOf(user.authenticationLevel || AuthenticationLevel.PUBLIC);
  return userAuthenticationLevelIdx >= requiredAuthenticationLevelIdx;
};
